import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faSearch,
  faHome,
  faShareSquare,
  faLock,
  faPhone,
  faMapMarkedAlt,
  faUser,
  faLayerGroup,
  faBuilding,
  faCube,
  faBookmark,
  faBars,
  faThLarge,
  faUserFriends,
  faArchway,
  faQuestionCircle,
  faUsers,
  faCog,
  faCircle,
  faFire,
  faMeteor,
  faSpinner,
  faChevronUp,
  faChevronDown,
  faTimes,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faFacebookSquare, faInstagram, faWhatsapp, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

export function loadIcons() {
  config.autoAddCss = true;
  library.add(
    faFacebookF,
    faFacebookSquare,
    faInstagram,
    faWhatsapp,
    faTwitter,
    faYoutube,
    faSearch,
    faHome,
    faShareSquare,
    faLock,
    faPhone,
    faMapMarkedAlt,
    faUser,
    faLayerGroup,
    faBuilding,
    faCube,
    faBookmark,
    faBars,
    faThLarge,
    faUserFriends,
    faArchway,
    faQuestionCircle,
    faUsers,
    faCog,
    faCircle,
    faFire,
    faMeteor,
    faSpinner,
    faChevronUp,
    faChevronDown,
    faTimes,
    faCheckCircle
  );

  Vue.component('Icon', FontAwesomeIcon);
}
